import { Routes } from '@angular/router';
import { AgendaComponent } from '../agenda/agenda.component';
import { BandejaComponent } from '../bandeja/bandeja.component';
import { EntradaComponent } from '../entrada/entrada.component';
import { TableroComponent } from '../tablero/tablero.component';
import { ReportesComponent } from '../reportes/reportes.component';
import { LoggerComponent } from '../logger/logger.component';
import { ValidaLectura } from '../guards/authenticated/authenticated.guard';

export const routesDashboard: Routes = [
    {path: '', redirectTo: 'agenda', pathMatch: 'full'},
    {path: 'agenda', component: AgendaComponent},
    {path: 'entrada/:tema/:id', component: EntradaComponent, canActivate: [ValidaLectura]},
    {path: 'entrada/:tema/:id/child', component: EntradaComponent},
    {path: 'bandeja', component: BandejaComponent},
    {path: 'tablero', component: TableroComponent},
    {path: 'reportes', component: ReportesComponent},
    {path: 'logs', component: LoggerComponent},
];